import gql from 'graphql-tag';

const NAME = 'compositions_CaseRequestsPanel_assetTypesQuery';

export default gql`
  query ${NAME} {
    assetType: __type(name: "AssetType") {
      enumValues {
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/RequestAssetsForm/RequestAsset/assetTypesQuery.js